import { navigate } from '@reach/router';
import { api } from '../../../api/api';
import { apis, inWindow } from '../../../config';
import { allAvailableNotificationType } from '../../../api/data/event';
import { util } from '@/api/util';
import { mailPerfTool } from '@/api/util/mail_perf';
import { config } from 'env_def';
import { getIn18Text } from '@/api/utils';
let _isEnableIM = true;
class PushHandlerApiImpl {
    constructor() {
        this.subAccountMailUnreadCount = new Map();
        this.allAccountNoticeInfo = new Map();
        this.getParams = (str, name) => {
            const reg = new RegExp(`${name}=([^\\?&]+)(?=(&|$))`);
            if (str.match(reg)) {
                return str.match(reg)[1];
            }
            return '';
        };
        this.openImSession = (paramsStr, str, type = 'hash') => {
            const sessionId = this.getParams(paramsStr, 'sessionId');
            const [scene, to] = sessionId.split('-');
            if (type === 'assign') {
                window.location.assign(str + paramsStr);
            }
            else {
                window.location.hash = str + paramsStr;
            }
            this.nimApi.currentSession.setPushSessionEvent({ scene, to });
        };
        this.name = apis.pushApiImpl;
        this.httpApi = api.getDataTransApi();
        this.eventApi = api.getEventApi();
        this.systemApi = api.getSystemApi();
        this.storeApi = api.getDataStoreApi();
        this.loginApi = api.requireLogicalApi(apis.loginApiImpl);
        this.accountApi = api.requireLogicalApi(apis.accountApiImpl);
        this.taskApi = api.requireLogicalApi(apis.taskApiImpl);
        this.nimApi = api.requireLogicalApi(apis.imApiImpl);
        this.resetCurrentNoToZero();
        this.currentNo = {
            im: 0,
            mail: 0,
            sys: 0,
            whatsApp: 0,
            facebook: 0,
        };
        this._handleSubAccountExpired = this._handleSubAccountExpired.bind(this);
    }
    updateIsEnableIMNotification() {
        try {
            const currentUser = this.systemApi.getCurrentUser();
            if (currentUser) {
                this.getCurrentPushConfig(1).then(res => {
                    if (res && res.success && res.data) {
                        _isEnableIM = res.data.isIMEnable;
                    }
                });
            }
        }
        catch (ex) {
            console.error('updateIsEnableIMNotification-catch', ex);
        }
    }
    afterLogin(ev) {
        var _a;
        if (ev && ev.data) {
            this.user = (_a = ev.data) === null || _a === void 0 ? void 0 : _a.eventData;
            if (this.user) {
                this.registerPush(this.user);
            }
            this.loadUnreadNum(this.user);
        }
        return this.name;
    }
    beforeLogout(ev) {
        var _a;
        if (ev && ev.data) {
            const user = (_a = ev.data) === null || _a === void 0 ? void 0 : _a.eventData;
            this.unregisterPush(user === null || user === void 0 ? void 0 : user.id);
            this.resetCurrentNoToZero(user === null || user === void 0 ? void 0 : user.id);
            this.currentNo = {
                im: 0,
                mail: 0,
                sys: 0,
                whatsApp: 0,
                facebook: 0,
            };
        }
        return this.name;
    }
    registerSubAccountUnreadCount(ev) {
        const { type, num } = ev.eventData;
        const subAccount = ev._account;
        if (type !== 'mail') {
            return;
        }
        if (num > 0) {
            this.subAccountMailUnreadCount.set(subAccount, num);
        }
        else if (num === 0) {
            this.subAccountMailUnreadCount.set(subAccount, 0);
        }
        this.pushNumChange('mail', subAccount);
    }
    registerPush(user) {
        if (config('stage') !== 'prod') {
            return;
        }
        this.httpApi
            .post(this.systemApi.getUrl('mailPushRegister'), {
            sources: 'pushmail',
            target: 'newclientPC',
            uid: user.id,
        }, { _account: user.id })
            .then(res => {
            console.log('[push] register push succeed:', res);
        })
            .catch(res => {
            console.warn('[push] register push failed:', res);
        });
    }
    unregisterPush(email) {
        console.log('email is ', email);
    }
    async getCurrentPushConfig(type = 0, _account) {
        try {
            const url = this.systemApi.getUrl('getPushConfig');
            return this.httpApi
                .post(url, { type }, { _account })
                .then(res => res.data)
                .then(res => {
                if (res && res.success && res.data === null) {
                    res.data = {
                        imPushSwitch: 1,
                        folderConfigs: [],
                        mailPushSwitch: 1,
                    };
                }
                if (res && res.success && res.data) {
                    const resData = res.data;
                    const isIMEnable = !!(resData.imPushSwitch && Number(resData.imPushSwitch) === 1);
                    const isMailEnable = !!(resData.mailPushSwitch && Number(resData.mailPushSwitch) === 1);
                    const disableFolders = type === 1
                        ? []
                        : (resData.folderConfigs || [])
                            .filter((configItem) => configItem && configItem.type === 0)
                            .map((configItem) => configItem.folderId);
                    return {
                        success: true,
                        data: {
                            isIMEnable,
                            disableFolders,
                            isMailEnable,
                        },
                    };
                }
                return {
                    success: false,
                    errorMsg: (res === null || res === void 0 ? void 0 : res.message) || '',
                };
            })
                .catch((err) => ({
                success: false,
                errorMsg: (err && err.message) || '',
            }));
        }
        catch (ex) {
            console.error('getCurrentPushConfig-catch', ex);
            return {
                success: false,
                errorMsg: (ex && ex.message) || '',
            };
        }
    }
    async cleanPushConfig(_account) {
        try {
            const url = this.systemApi.getUrl('cleanPushConfig');
            return this.httpApi
                .post(url, undefined, { _account })
                .then(res => res.data)
                .then(res => {
                if (res && res.success && res.data) {
                    return {
                        success: true,
                    };
                }
                return {
                    success: false,
                    errorMsg: (res === null || res === void 0 ? void 0 : res.message) || '',
                };
            })
                .catch(err => ({
                success: false,
                errorMsg: (err && err.message) || '',
            }));
        }
        catch (err) {
            return {
                success: false,
                errorMsg: (err && err.message) || '',
            };
        }
    }
    async setPushConfigToServer(config, _account) {
        try {
            const url = this.systemApi.getUrl('setPushConfig');
            const deviceInfo = this.httpApi.getDeviceInfo();
            const currentUser = this.systemApi.getCurrentUser(_account);
            if (!currentUser) {
                return {
                    success: false,
                    errorMsg: 'not login',
                };
            }
            const isThirdSubAccount = this.systemApi.getIsThirdSubAccountByEmailId(currentUser.id || '');
            const mainAndSubAccount = isThirdSubAccount ? `${currentUser.id}}` : '';
            const userInfo = await this.accountApi.getCurrentAccountInfo(currentUser.id, _account || '');
            const yunxinAccountId = isThirdSubAccount ? 'unused' + this.systemApi.md5(`${userInfo.qiyeAccountId}-${mainAndSubAccount}`) : userInfo.yunxinAccountId;
            const resData = await this.httpApi
                .post(url, {
                _system: deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo._system,
                _platform: deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.p,
                yxAccId: yunxinAccountId,
                imPushSwitch: config.isIMEnable ? 1 : 0,
                imPushSound: 'default',
                mailPushSwitch: config.isMailEnable ? 1 : 0,
                mailPushSound: 'default',
                folderConfigs: (config.disableFolders || []).map(folderId => ({
                    folderId,
                })),
            }, { contentType: 'json', _account })
                .then(res => res.data);
            if (resData && resData.success) {
                _isEnableIM = !!config.isIMEnable;
                return {
                    success: true,
                };
            }
            return {
                success: false,
                errorMsg: (resData === null || resData === void 0 ? void 0 : resData.error) || '',
            };
        }
        catch (ex) {
            console.error('setPushConfigToServer-error', ex);
            return {
                success: false,
                errorMsg: (ex && ex.message) || '',
            };
        }
    }
    async setCurrentConfig(config, _account) {
        try {
            let fullSetConfig = null;
            const noIMEnableInParam = typeof config.isIMEnable === 'undefined';
            const noDisableFoldersInParam = typeof config.disableFolders === 'undefined';
            const noMailEnableInParam = typeof config.isMailEnable === 'undefined';
            if (noIMEnableInParam && noDisableFoldersInParam && noMailEnableInParam) {
                return {
                    success: true,
                };
            }
            else {
                const serverConfig = await this.getCurrentPushConfig(undefined, _account);
                if (!serverConfig.success) {
                    return {
                        success: false,
                        errorMsg: serverConfig.errorMsg,
                    };
                }
                const configData = serverConfig.data;
                if (configData) {
                    fullSetConfig = {
                        isIMEnable: noIMEnableInParam ? configData.isIMEnable : config.isIMEnable,
                        disableFolders: noDisableFoldersInParam ? configData.disableFolders : config.disableFolders,
                        isMailEnable: noMailEnableInParam ? configData.isMailEnable : config.isMailEnable,
                    };
                    const serverRes = await this.setPushConfigToServer(fullSetConfig, _account);
                    return serverRes;
                }
                return {
                    success: false,
                };
            }
        }
        catch (ex) {
            console.error('setCurrentConfig-catch', ex);
            return {
                success: false,
                errorMsg: (ex && ex.message) || '',
            };
        }
    }
    getNotificationCount() {
        return this.currentNo;
    }
    triggerNotificationInfoChange(content, _account = '') {
        var _a;
        console.log('[push] $$$$$ trigger push:', content);
        let needChangeNum = false;
        let type;
        const currentUserId = ((_a = this.systemApi.getCurrentUser(_account)) === null || _a === void 0 ? void 0 : _a.id) || '';
        const currentNotice = this.allAccountNoticeInfo.get(currentUserId);
        if (!currentNotice) {
            return;
        }
        switch (content.action) {
            case 'new_im_msg':
            case 'new_im_gp_msg':
                this.pushNotification(content, 'im');
                break;
            case 'new_im_noti':
                break;
            case 'new_im_msg_num':
                currentNotice.im = content.num;
                type = 'im';
                needChangeNum = true;
                break;
            case 'new_im_msg_inc':
                currentNotice.im += content.num;
                type = 'im';
                needChangeNum = true;
                break;
            case 'new_mail':
                this.pushNotification(content, 'mail');
                this.eventApi.sendSysEvent({
                    eventName: 'mailPushNotify',
                    eventData: {
                        mid: content.mailId,
                        accountId: content.accountId,
                    },
                    eventSeq: 0,
                    eventStrData: 'notify',
                });
                break;
            case 'new_mail_num': {
                const pre = currentNotice.mail;
                currentNotice.mail = content.num;
                type = 'mail';
                needChangeNum = pre !== currentNotice.mail;
                break;
            }
            case 'im_clear': {
                const pre = currentNotice.im;
                type = 'im';
                currentNotice.im = 0;
                needChangeNum = pre !== currentNotice.im;
                break;
            }
            case 'mail_clear': {
                const pre = currentNotice.mail;
                type = 'mail';
                currentNotice.mail = 0;
                needChangeNum = pre !== currentNotice.mail;
                break;
            }
            case 'whatsApp': {
                this.pushNotification(content, 'whatsApp');
                break;
            }
            case 'facebook': {
                this.pushNotification(content, 'facebook');
                break;
            }
            default:
                break;
        }
        this.allAccountNoticeInfo.set(currentUserId, currentNotice);
        this.storeUnhandedData(currentNotice, currentUserId);
        if (needChangeNum) {
            this.pushNumChange(type, _account);
        }
    }
    getTotalNum(data) {
        let num = 0;
        Object.keys(this.currentNo).forEach(it => {
            num += data[it] || 0;
        });
        const totalSubAccountUnreadAccount = [...this.subAccountMailUnreadCount.values()].reduce((total, cur) => total + cur, 0);
        num += Number.isSafeInteger(totalSubAccountUnreadAccount) ? Math.max(totalSubAccountUnreadAccount, 0) : 0;
        return num;
    }
    getUnreadCount(type) {
        var _a;
        const currentAccount = (_a = this.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id;
        const currentNoticeInfo = this.allAccountNoticeInfo.get(currentAccount || '');
        if (type !== 'mail') {
            if (currentNoticeInfo) {
                return currentNoticeInfo[type];
            }
            return this.currentNo[type];
        }
        const totalSubAccountUnreadAccount = [...this.subAccountMailUnreadCount.values()].reduce((total, cur) => total + cur, 0);
        return ((currentNoticeInfo === null || currentNoticeInfo === void 0 ? void 0 : currentNoticeInfo.mail) || 0) + (Number.isSafeInteger(totalSubAccountUnreadAccount) ? Math.max(totalSubAccountUnreadAccount, 0) : 0);
    }
    storeUnhandedData(data, _account = '') {
        this.storeApi.put(PushHandlerApiImpl.unhandledNotificationNumKey, JSON.stringify(data), { _account }).then();
    }
    pushNumChange(type, _account) {
        var _a, _b;
        const mainAccount = ((_a = this.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '';
        if (_account && _account !== ((_b = this.systemApi.getCurrentUser()) === null || _b === void 0 ? void 0 : _b.id)) {
            if ((type === 'mail' || !type) && this.allAccountNoticeInfo.has(_account)) {
                const currentNoticeInfo = this.allAccountNoticeInfo.get(_account);
                const num = (currentNoticeInfo === null || currentNoticeInfo === void 0 ? void 0 : currentNoticeInfo.mail) || 0;
                if (num > 0) {
                    this.subAccountMailUnreadCount.set(_account, num);
                }
                else if (num === 0) {
                    this.subAccountMailUnreadCount.set(_account, 0);
                }
            }
        }
        const currentNoticeInfo = this.allAccountNoticeInfo.get(mainAccount);
        this.systemApi.updateAppNotification({
            type: ['macDocker'],
            content: {
                num: this.getTotalNum(currentNoticeInfo || this.currentNo),
                title: '',
                code: '',
            },
        });
        if (type) {
            this.eventApi.sendSysEvent({
                eventSeq: 0,
                eventStrData: type,
                eventName: 'notificationChange',
                eventData: this.getUnreadCount(type),
            });
        }
        else {
            allAvailableNotificationType.forEach(str => {
                if (currentNoticeInfo && currentNoticeInfo[str] && currentNoticeInfo[str] > 0) {
                    this.eventApi.sendSysEvent({
                        eventSeq: 0,
                        eventStrData: str,
                        eventName: 'notificationChange',
                        eventData: this.getUnreadCount(str),
                    });
                }
            });
        }
    }
    static handleNotificationContent(str) {
        const len = util.isMac() ? 40 : 64;
        const { chatLen: totalLen, real: result } = [...str].reduce(({ chatLen, real }, item) => {
            if (chatLen < len) {
                if (/[\u4e00-\u9fa5]/.test(item)) {
                    chatLen += 2;
                }
                else {
                    chatLen += 1;
                }
                real += item;
            }
            return {
                chatLen,
                real,
            };
        }, { chatLen: 0, real: '' });
        return totalLen < len ? result : result + '...';
    }
    isCurrrentAccountNotification(accountInfo, accountId) {
        if (!accountInfo || !accountId) {
            return false;
        }
        return accountInfo.id && this.systemApi.md5(accountInfo.id) === accountId;
    }
    async pushNotification(content, type) {
        var _a;
        let isOwner;
        let notificationContent = content.content;
        let receiveSubAccount;
        let isSubAccountNotification = false;
        if (type === 'im' && !_isEnableIM) {
            return;
        }
        let sharedAccount;
        if (type === 'mail') {
            const currentUser = this.systemApi.getCurrentUser();
            if (!currentUser) {
                return;
            }
            const accountMd5 = this.systemApi.md5(currentUser.id);
            isOwner = content.accountId ? content.accountId === accountMd5 && !currentUser.isSharedAccount : true;
            const receiveSubAccounts = (await this.accountApi.getSubAccounts({ expired: false })) || [];
            receiveSubAccount = receiveSubAccounts.find(subAccount => this.isCurrrentAccountNotification(subAccount, content === null || content === void 0 ? void 0 : content.accountId));
            const sharedAccountInfo = await this.accountApi.getSharedAccountsInfoAsync();
            isSubAccountNotification = !!receiveSubAccount;
            isOwner = isOwner || isSubAccountNotification;
            console.warn('pushNotification isOwner', isOwner);
            if (!isOwner) {
                if (!process.env.BUILD_ISELECTRON) {
                    return;
                }
                const { localList } = await this.accountApi.doGetAccountList();
                const receiveAccount = localList.find(item => this.isCurrrentAccountNotification(item, content === null || content === void 0 ? void 0 : content.accountId));
                sharedAccount = (_a = sharedAccountInfo === null || sharedAccountInfo === void 0 ? void 0 : sharedAccountInfo.sharedAccounts) === null || _a === void 0 ? void 0 : _a.find(account => this.systemApi.md5(account.email) === (content === null || content === void 0 ? void 0 : content.accountId));
                if (currentUser.isSharedAccount && (sharedAccountInfo === null || sharedAccountInfo === void 0 ? void 0 : sharedAccountInfo.email) && this.systemApi.md5(sharedAccountInfo === null || sharedAccountInfo === void 0 ? void 0 : sharedAccountInfo.email) === (content === null || content === void 0 ? void 0 : content.accountId)) {
                    sharedAccount = sharedAccountInfo;
                }
                if (!receiveAccount && !sharedAccount) {
                    return;
                }
                if (receiveAccount === null || receiveAccount === void 0 ? void 0 : receiveAccount.nickName) {
                    notificationContent =
                        PushHandlerApiImpl.handleNotificationContent(notificationContent) + getIn18Text('LAIZI：') + receiveAccount.nickName + '(' + receiveAccount.id + ')';
                }
                else if (receiveAccount === null || receiveAccount === void 0 ? void 0 : receiveAccount.accountName) {
                    notificationContent = PushHandlerApiImpl.handleNotificationContent(notificationContent) + getIn18Text('LAIZI：') + receiveAccount.accountName;
                }
                if (process.env.BUILD_ISELECTRON && (sharedAccount || receiveAccount)) {
                    const emailList = [];
                    if (sharedAccount) {
                        emailList.push(sharedAccount.email);
                    }
                    if (receiveAccount) {
                        emailList.push(receiveAccount.id);
                    }
                    await this.accountApi.updateSidebarDockUnreadStatus(emailList, true);
                    this.eventApi.sendSimpleSysEvent('accountNotify');
                }
            }
        }
        this.systemApi.updateAppNotification({
            type: ['windowsFlush'],
            content: {
                num: this.getTotalNum(this.currentNo),
                title: '',
                code: '',
            },
        });
        if (this.systemApi.isElectron() && (await window.electronLib.appManage.isAppLockScreen())) {
            return;
        }
        this.systemApi
            .showSysNotification({
            code: '',
            tag: type,
            title: content.title,
            content: notificationContent,
            confirmCallback: async (ev) => {
                const isUnLockApp = this.systemApi.getIsLockApp();
                if (isUnLockApp)
                    return;
                console.log('[push] confirm clicked:', ev);
                const idPart = content.data || '';
                if (process.env.BUILD_ISELECTRON) {
                    window.electronLib.windowManage.show();
                    if (this.systemApi.isMainPage()) {
                        if (type === 'mail') {
                            if (!isOwner) {
                                const suc = await this.handleMultiAccount(content);
                                if (suc) {
                                    return;
                                }
                                if (sharedAccount) {
                                    await this.handleSharedAccount(sharedAccount.email, content.mailId || '');
                                }
                                else {
                                    await this.handleLocalAccount(content);
                                }
                            }
                            else {
                                mailPerfTool.mailContent('push', 'start', {
                                    isThread: false,
                                });
                                const account = isSubAccountNotification ? (receiveSubAccount === null || receiveSubAccount === void 0 ? void 0 : receiveSubAccount.id) || '' : '';
                                this.systemApi
                                    .createWindowWithInitData({ type: 'readMail', additionalParams: { account } }, {
                                    eventName: 'initPage',
                                    eventData: { id: content === null || content === void 0 ? void 0 : content.mailId, accountId: account },
                                    eventStrData: 'push',
                                })
                                    .then();
                            }
                        }
                        else if (type === 'im') {
                            const isWaimao = this.systemApi.inEdm();
                            if (isWaimao) {
                                this.openImSession(idPart, 'sirius://sirius.page/#coop?page=message&', 'assign');
                            }
                            else {
                                this.openImSession(idPart, 'sirius://sirius.page/#message?', 'assign');
                            }
                        }
                        else {
                            window.location.assign('sirius://sirius.page/#mailbox?' + idPart);
                        }
                    }
                    if (ev.target.close && typeof ev.target.close === 'function') {
                        ev.target.close();
                    }
                }
                else if (inWindow()) {
                    window.focus();
                    if (this.systemApi.isMainPage()) {
                        if (type === 'mail') {
                            window.open(`${this.systemApi.getContextPath()}/readMail/?id=${content === null || content === void 0 ? void 0 : content.mailId}&push=1`, 'readMail', 'menubar=0,scrollbars=1,resizable=1,width=800,height=600');
                            return;
                        }
                        if (type === 'im') {
                            this.openImSession(idPart, `${this.systemApi.isWebWmEntry() ? '#coop?page=message&' : '#message?'}`);
                            return;
                        }
                        window.location.hash = '#mailbox?' + idPart;
                    }
                }
                if (type === 'mail') {
                    this.eventApi.sendSysEvent({
                        eventName: 'mailChanged',
                        eventData: '1',
                        eventSeq: 0,
                        eventStrData: '',
                    });
                }
                if (type === 'whatsApp') {
                    if (content.data) {
                        try {
                            const { chatId, from } = JSON.parse(content.data);
                            const url = !from ? `#edm?page=whatsAppMessage&chatId=${chatId}` : `#edm?page=whatsAppMessage&chatId=${chatId}&from=${from}`;
                            this.eventApi.sendSysEvent({
                                eventName: 'routeChange',
                                eventStrData: 'gatsbyStateNav',
                                eventData: { url },
                            });
                        }
                        catch (_a) { }
                    }
                    if (typeof ev.target.close === 'function') {
                        ev.target.close();
                    }
                }
                if (type === 'facebook') {
                    if (content.data) {
                        try {
                            const { pageId, contactId } = JSON.parse(content.data);
                            navigate(`#edm?page=facebookMessage&pageId=${pageId}&contactId=${contactId}`);
                        }
                        catch (error) {
                            console.warn(error);
                        }
                        if (typeof ev.target.close === 'function') {
                            ev.target.close();
                        }
                    }
                }
            },
        })
            .then();
    }
    async handleMultiAccount(content) {
        const bindAccount = await this.accountApi.getMainAndSubAccounts({ expired: false });
        const curAccount = bindAccount.find(item => item.id && this.systemApi.md5(item.id) === (content === null || content === void 0 ? void 0 : content.accountId));
        if (!curAccount) {
            return false;
        }
        this.systemApi
            .createWindowWithInitData({ type: 'readMail', additionalParams: { account: curAccount.id } }, {
            eventName: 'initPage',
            eventData: content === null || content === void 0 ? void 0 : content.mailId,
            eventStrData: 'push',
        })
            .then();
        return true;
    }
    async createMailPushTask(account, mailId) {
        try {
            if (!mailId)
                return;
            await this.taskApi.doCreateTask({
                account,
                action: 'AfterLogin',
                from: 'mail_push',
                to: 'mail',
                content: { mailId: mailId },
            });
        }
        catch (e) {
            console.error('[push] push 创建任务失败！！！！', e);
        }
    }
    async switchSharedAccount(email) {
        try {
            const res = await this.loginApi.switchSharedAccount(email);
            if (!res.success) {
                this.eventApi.sendSysEvent({
                    eventName: 'error',
                    eventLevel: 'error',
                    eventStrData: '',
                    eventData: {
                        forcePopup: true,
                        popupType: 'window',
                        title: getIn18Text('TISHI'),
                        popupLevel: 'error',
                        content: res.errMsg || getIn18Text('SWITCH_SHARED_ACCOUNT_ERROR'),
                        code: 'PARAM.ERR',
                    },
                    eventSeq: 0,
                });
            }
        }
        catch (ex) {
            console.error('switchSharedAccount-error', ex);
        }
    }
    async handleSharedAccount(email, mailId) {
        try {
            if (!email || !mailId)
                return;
            await this.createMailPushTask(email, mailId);
            await this.switchSharedAccount(email);
        }
        catch (ex) {
            console.error('handleSharedAccount-error', ex);
        }
    }
    async handleLocalAccount(content) {
        const { localList } = await this.accountApi.doGetAccountList();
        const cur = localList.find(item => item.id && this.systemApi.md5(item.id) === (content === null || content === void 0 ? void 0 : content.accountId));
        const account = cur && cur.id;
        if (!account) {
            return;
        }
        await this.createMailPushTask(account, content.mailId || '');
        this.handleAccountSwitch(account).then();
    }
    async handleAccountSwitch(account) {
        var _a;
        this.eventApi.sendSysEvent({
            eventName: 'error',
            eventLevel: 'error',
            eventStrData: '',
            eventData: {
                popupType: 'toast',
                popupLevel: 'info',
                title: getIn18Text('ZHANGHAOQIEHUANZHONG..'),
                code: 'PARAM.ERR',
            },
            eventSeq: 0,
        });
        const preAccount = (_a = this.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id;
        const { pass } = await this.loginApi.doAutoLoginInCurrentPage(account, true);
        if (!pass) {
            this.eventApi.sendSysEvent({
                eventName: 'error',
                eventLevel: 'error',
                eventStrData: '',
                eventData: {
                    forcePopup: true,
                    popupType: 'window',
                    popupLevel: 'error',
                    title: getIn18Text('DENGLUZHUANGTAISHIXIAO'),
                    content: `账号：${account}登录状态失效，无法切换，请重新选择账号登录`,
                    code: 'PARAM.ERR',
                    confirmCallback: () => {
                        if (preAccount) {
                            this.loginApi.doAutoLoginInCurrentPage(preAccount).then((res) => {
                                if (res.pass) {
                                    location.assign('/#setting');
                                }
                                else {
                                    window.electronLib.windowManage.reload();
                                }
                            });
                        }
                        else {
                            window.electronLib.windowManage.reload();
                        }
                    },
                },
                eventSeq: 0,
            });
        }
    }
    startBindDevice(_account) {
        if (config('stage') !== 'prod') {
            return;
        }
        if (this.systemApi.isMainPage()) {
            this.systemApi.intervalEvent({
                seq: 1,
                eventPeriod: config && config('stage') !== 'prod' ? 'long' : 'extLong',
                id: 'intervalBindDeice',
                handler: handler => {
                    if (handler.seq > 0 && handler.seq % (config && config('stage') !== 'prod' ? 1 : 3) === 0) {
                        this.systemApi.getCurrentUser(_account) && this.loginApi.bindAccountDevice();
                    }
                },
            });
        }
    }
    resetCurrentNoToZero(email) {
        if (email) {
            this.allAccountNoticeInfo.set(email, {
                im: 0,
                mail: 0,
                sys: 0,
                whatsApp: 0,
                facebook: 0,
            });
            this.subAccountMailUnreadCount.set(email, 0);
        }
        this.currentNo = {
            im: 0,
            mail: 0,
            sys: 0,
            whatsApp: 0,
            facebook: 0,
        };
    }
    loadUnreadNum(user) {
        const currentUser = this.systemApi.getCurrentUser(user === null || user === void 0 ? void 0 : user.id);
        const mainAccount = this.systemApi.getCurrentUser();
        if (currentUser) {
            this.storeApi.get(PushHandlerApiImpl.unhandledNotificationNumKey, { _account: currentUser.id }).then(res => {
                if (res && res.suc && res.data) {
                    const data = JSON.parse(res.data);
                    this.allAccountNoticeInfo.set(currentUser.id, data);
                    if ((mainAccount === null || mainAccount === void 0 ? void 0 : mainAccount.id) !== currentUser.id) {
                        this.subAccountMailUnreadCount.set(currentUser.id, data === null || data === void 0 ? void 0 : data.mail);
                    }
                }
                else {
                    this.resetCurrentNoToZero(currentUser.id);
                    this.currentNo = {
                        im: 0,
                        mail: 0,
                        sys: 0,
                        whatsApp: 0,
                        facebook: 0,
                    };
                }
                this.pushNumChange(undefined, currentUser.id);
            });
        }
        else {
            this.resetCurrentNoToZero();
            this.currentNo = {
                im: 0,
                mail: 0,
                sys: 0,
                whatsApp: 0,
                facebook: 0,
            };
            this.pushNumChange();
        }
        console.log('[push] $$$ load unreadnum:', [...this.allAccountNoticeInfo.entries()]);
    }
    init() {
        return this.name;
    }
    afterInit() {
        setTimeout(() => {
            this.updateIsEnableIMNotification();
        }, 100);
        return this.name;
    }
    updateSubAccountNoticeInfo() {
        const accountList = this.storeApi.getSubAccountList();
        accountList.forEach(item => {
            this.registerPush({ id: item.email });
            this.loadUnreadNum({ id: item.email });
        });
    }
    _handleSubAccountExpired(ev) {
        if (ev && ev.eventData) {
            const { eventData } = ev;
            const { subAccount } = eventData;
            if (this.subAccountMailUnreadCount.has(subAccount)) {
                this.subAccountMailUnreadCount.delete(subAccount);
            }
            if (this.allAccountNoticeInfo.has(subAccount)) {
                this.allAccountNoticeInfo.delete(subAccount);
            }
            this.pushNumChange('mail', subAccount);
        }
    }
    afterLoadFinish() {
        if (inWindow()) {
            if (PushHandlerApiImpl.inited) {
                return this.name;
            }
            this.httpApi.addConfig({
                matcher: /\/qiyepush\/open\/subscribe/i,
                requestAutoReLogin(data) {
                    return data.status === 403 || (!!data.data && !!data.data.code && (String(data.data.code) === '403' || String(data.data.code) === '401'));
                },
                reLoginUrlHandler: conf => conf,
            });
            PushHandlerApiImpl.inited = true;
            const currentUser = this.systemApi.getCurrentUser();
            if (currentUser) {
                this.startBindDevice(currentUser.id);
                this.registerPush(currentUser);
                this.loadUnreadNum();
                this.updateSubAccountNoticeInfo();
            }
            const isMainPage = this.systemApi.isMainPage();
            if (isMainPage || process.env.BUILD_ISWEB) {
                this.eventApi.registerSysEventObserver('SubAccountDeleted', {
                    name: 'SubAccountDeleted-PushImpl',
                    func: this._handleSubAccountExpired,
                });
                this.eventApi.registerSysEventObserver('SubAccountLoginExpired', {
                    name: 'SubAccountLoginExpired-PushImpl',
                    func: this._handleSubAccountExpired,
                });
                this.eventApi.registerSysEventObserver('SubAccountAdded', {
                    name: 'SubAccountAdded-PushImpl',
                    func: ev => {
                        if (ev && ev.eventData) {
                            const { eventData } = ev;
                            const { subAccount } = eventData;
                            this.registerPush({ id: subAccount });
                            this.loadUnreadNum({ id: subAccount });
                            this.pushNumChange('mail', subAccount);
                        }
                    },
                });
            }
        }
        return this.name;
    }
}
PushHandlerApiImpl.inited = false;
PushHandlerApiImpl.unhandledNotificationNumKey = 'unhandledNotificationCount';
const pushApi = new PushHandlerApiImpl();
api.registerLogicalApi(pushApi);
export default pushApi;
